// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IVp9R_8GAD4Dz0tf6WY8>div>*{overflow:visible}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagModal": `IVp9R_8GAD4Dz0tf6WY8`
};
export default ___CSS_LOADER_EXPORT___;
